import { FunctionComponent } from 'react';
import styled from 'styled-components';

import theme from '@/styles/theme';
import { DIRECTION } from '@/types/common';

interface ArrowCaretProps {
  direction?: DIRECTION;
  color?: string;
  size?: number;
}

/**
 * @default
 * direction: DIRECTION.RIGHT,
 * color: theme.color.primary500,
 * size: 16,
 */

const ArrowCaret: FunctionComponent<ArrowCaretProps> = ({
  direction = DIRECTION.RIGHT,
  color = theme.color.primary500,
  size = 16,
}) => {
  return (
    <ArrowSVG
      direction={direction}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1782 7.635C11.3849 7.83656 11.3849 8.16336 11.1782 8.36492L6.23701 13.1821C6.03027 13.3837 5.69506 13.3837 5.48831 13.1821C5.28157 12.9806 5.28157 12.6538 5.48831 12.4522L10.0551 7.99996L5.48831 3.54771C5.28157 3.34615 5.28157 3.01936 5.48831 2.8178C5.69506 2.61624 6.03027 2.61624 6.23702 2.8178L11.1782 7.635Z"
        fill={color}
      />
    </ArrowSVG>
  );
};

export default ArrowCaret;

const ArrowSVG = styled.svg<{ direction: DIRECTION }>`
  transition: transform 0.1s linear;
  transform: rotate(
    ${({ direction }) =>
      direction === DIRECTION.TOP
        ? -90
        : direction === DIRECTION.BOTTOM
        ? 90
        : direction === DIRECTION.LEFT
        ? 180
        : 0}deg
  );
`;
